/* Change menu link based on homepage selection */
(function () {
  var COOKIE_NAME = 'mens_pref';
  var COOKIE_DAYS = 30;
  var WOMEN_SALE_PATH = '/pages/women-fall-sale';
  var MEN_SALE_PATH = '/pages/men-fall-sale';

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/;SameSite=Lax";
  }

  function getCookie(name) {
    var cname = name + "=";
    var decoded = document.cookie.split(';');
    for (var i = 0; i < decoded.length; i++) {
      var c = decoded[i].trim();
      if (c.indexOf(cname) === 0) return decodeURIComponent(c.substring(cname.length, c.length));
    }
    return null;
  }

  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; SameSite=Lax";
  }

  function isPath(href, path) {
    try {
      var u = new URL(href, window.location.origin);
      var a = u.pathname.replace(/\/+$/, '');
      var b = path.replace(/\/+$/, '');
      return a === b;
    } catch (e) {
      return (href || '').split('?')[0].replace(/\/+$/, '') === path.replace(/\/+$/, '');
    }
  }

  function rewriteNavLinks(toMen) {
    var links = document.querySelectorAll('.site-nav__item > a, .site-nav a, nav a');
    links.forEach(function (a) {
      if (!a.dataset.origWomenHref && isPath(a.getAttribute('href') || '', WOMEN_SALE_PATH)) {
        a.dataset.origWomenHref = a.getAttribute('href');
      }
      if (toMen) {
        if (isPath(a.getAttribute('href') || '', WOMEN_SALE_PATH)) {
          var menUrl = (a.getAttribute('href') || '').replace(WOMEN_SALE_PATH, MEN_SALE_PATH);
          a.setAttribute('href', menUrl);
        }
      } else {
        if (a.dataset.origWomenHref && isPath(a.getAttribute('href') || '', MEN_SALE_PATH)) {
          a.setAttribute('href', a.dataset.origWomenHref);
        } else if (!a.dataset.origWomenHref && isPath(a.getAttribute('href') || '', MEN_SALE_PATH)) {
          var womenUrl = (a.getAttribute('href') || '').replace(MEN_SALE_PATH, WOMEN_SALE_PATH);
          a.setAttribute('href', womenUrl);
        }
      }
    });
  }

  function applyStateFromCookie() {
    var hasPref = getCookie(COOKIE_NAME) === '1';
    rewriteNavLinks(hasPref);
  }

  function onClick(e) {
    var a = e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var inPromo = !!a.closest('.promo-grid');
    var inNavItem = !!a.closest('.site-nav__item');

    if ((inPromo || inNavItem) && isPath(href, '/pages/mens')) {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      rewriteNavLinks(true);
      return;
    }
    if ((inPromo || inNavItem) && isPath(href, '/pages/womens')) {
      deleteCookie(COOKIE_NAME);
      rewriteNavLinks(false);
      return;
    }
    if (inNavItem && isPath(href, '/pages/shop-all-mens')) {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      rewriteNavLinks(true);
      return;
    }
    if (inNavItem && isPath(href, '/pages/shop-all-womens')) {
      deleteCookie(COOKIE_NAME);
      rewriteNavLinks(false);
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStateFromCookie, { once: true });
  } else {
    applyStateFromCookie();
  }
  document.addEventListener('click', onClick, true);
  document.addEventListener('shopify:section:load', applyStateFromCookie);
  document.addEventListener('shopify:section:reorder', applyStateFromCookie);
  document.addEventListener('shopify:section:unload', applyStateFromCookie);
})();

/* Custom scrollbar in about page */
document.addEventListener('DOMContentLoaded', function () {
  function attachCustomScrollbar(selector) {
    const list = document.querySelector(selector);
    if (!list) return;

    const scrollbar = document.createElement('div');
    scrollbar.className = 'goth-scrollbar';
    const thumb = document.createElement('div');
    thumb.className = 'goth-scrollbar__thumb';
    scrollbar.appendChild(thumb);
    list.insertAdjacentElement('afterend', scrollbar);

    let dragging = false;
    let dragStartX = 0;
    let startScrollLeft = 0;

    function updateThumb() {
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;
      const scrollLeft = list.scrollLeft;

      if (scrollWidth <= clientWidth) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
        return;
      }

      const barWidth = scrollbar.clientWidth;
      const visibleRatio = clientWidth / scrollWidth;
      const thumbWidth = Math.max(visibleRatio * barWidth, 20);
      const maxThumbLeft = barWidth - thumbWidth;
      const scrollRatio = scrollLeft / (scrollWidth - clientWidth);
      const thumbLeft = scrollRatio * maxThumbLeft;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.left = thumbLeft + 'px';
    }

    list.addEventListener('scroll', () => requestAnimationFrame(updateThumb));
    new ResizeObserver(() => requestAnimationFrame(updateThumb)).observe(list);
    new ResizeObserver(() => requestAnimationFrame(updateThumb)).observe(scrollbar);

    scrollbar.addEventListener('mousedown', (e) => {
      if (e.target === thumb) return;
      const rect = scrollbar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const barWidth = rect.width;
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;
      const targetRatio = Math.min(Math.max(clickX / barWidth, 0), 1);
      const targetScrollLeft = targetRatio * (scrollWidth - clientWidth);
      list.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    });

    thumb.addEventListener('mousedown', (e) => {
      dragging = true;
      dragStartX = e.clientX;
      startScrollLeft = list.scrollLeft;
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      const barWidth = scrollbar.clientWidth;
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      const dx = e.clientX - dragStartX;
      const visibleRatio = clientWidth / scrollWidth;
      const thumbWidth = Math.max(visibleRatio * barWidth, 20);
      const maxThumbLeft = barWidth - thumbWidth;
      const scrollPerPx = maxScroll / maxThumbLeft;
      list.scrollLeft = Math.min(Math.max(startScrollLeft + dx * scrollPerPx, 0), maxScroll);
    });

    window.addEventListener('mouseup', () => { dragging = false; });

    thumb.addEventListener('touchstart', (e) => {
      dragging = true;
      dragStartX = e.touches[0].clientX;
      startScrollLeft = list.scrollLeft;
    }, { passive: true });

    window.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      const barWidth = scrollbar.clientWidth;
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      const dx = e.touches[0].clientX - dragStartX;
      const visibleRatio = clientWidth / scrollWidth;
      const thumbWidth = Math.max(visibleRatio * barWidth, 20);
      const maxThumbLeft = barWidth - thumbWidth;
      const scrollPerPx = maxScroll / maxThumbLeft;
      list.scrollLeft = Math.min(Math.max(startScrollLeft + dx * scrollPerPx, 0), maxScroll);
    }, { passive: true });

    window.addEventListener('touchend', () => { dragging = false; });

    updateThumb();
  }

  attachCustomScrollbar('.page-template--about .section--divider .grid');
});

/* Cart upsells */
(function () {
  if (window.__gothCartUpsells2) return;
  window.__gothCartUpsells2 = true;

  function norm(s) {
    return String(s || '').replace(/[’]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function drawerRoot() {
    return document.getElementById('CartDrawer');
  }

  function cardOf(el) {
    return el && (el.closest('[data-product-id]') || el.closest('.grid__item') || el.closest('.grid-product'));
  }

  async function addToCart(variantId, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty || 1) })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function fire(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  function rekeyCard(card) {
    if (!card || card.dataset.upsellsRekeyed === '1') return;
    var pid = card.getAttribute('data-product-id');
    if (!pid) return;

    var radios = card.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var oldId = r.getAttribute('id') || ('r' + i);
      var oldName = r.getAttribute('name') || 'opt';

      var baseName = oldName.replace(/[^a-z0-9_-]/gi, '');
      var newName = baseName + '-' + pid;
      var newId = oldId.replace(/[^a-z0-9_-]/gi, '') + '-' + pid + '-' + i;

      var label = card.querySelector('label[for="' + CSS.escape(oldId) + '"]');

      r.setAttribute('name', newName);
      r.setAttribute('id', newId);
      if (label) label.setAttribute('for', newId);
    }

    card.dataset.upsellsRekeyed = '1';
  }

  function getCartOptionsFromDrawer() {
    var root = drawerRoot();
    if (!root) return null;

    var item = root.querySelector('.cart__item');
    if (!item) return null;

    var rows = item.querySelectorAll('.cart__item--variants > div');
    if (!rows || !rows.length) return null;

    var map = {};
    for (var i = 0; i < rows.length; i++) {
      var div = rows[i];
      var span = div.querySelector('span');
      if (!span) continue;

      var key = norm(span.textContent).replace(/:$/, '').replace(/[^a-z0-9]+/g, '');
      var val = norm(div.textContent.replace(span.textContent, ''));
      if (key && val) map[key] = val;
    }

    return Object.keys(map).length ? map : null;
  }

  function groupKeyFromName(name) {
    return norm(name).split('-')[0];
  }

  function setRadioInCard(card, groupKey, desiredValue) {
    desiredValue = norm(desiredValue);
    if (!desiredValue) return false;

    var inputs = card.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var r = inputs[i];
      if (groupKeyFromName(r.name || '') !== groupKey) continue;

      var id = r.getAttribute('id');
      var lab = id ? card.querySelector('label[for="' + CSS.escape(id) + '"]') : null;
      var lv = norm((lab && lab.dataset && lab.dataset.title) ? lab.dataset.title : (lab ? lab.textContent : ''));
      var iv = norm(r.value);

      if (lv === desiredValue || iv === desiredValue) {
        r.checked = true;
        return true;
      }
    }

    return false;
  }

  function setSelectByTitle(card, color, size) {
    var select = card.querySelector('.c_p-addon-master');
    if (!select) return;

    var want = norm(color) + ' / ' + norm(size);
    if (!want.trim()) return;

    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var t = norm((opt.dataset && opt.dataset.title) ? opt.dataset.title : opt.textContent);
      if (t === want) {
        select.value = opt.value;
        return;
      }
    }
  }

  function getVariantId(card) {
    var select = card.querySelector('.c_p-addon-master');
    if (!select) return null;
    if (select.value) return select.value;
    if (select.options && select.options.length) return select.options[0].value;
    return null;
  }

  var syncing = false;

  function syncUpsellsFromDrawer() {
    if (syncing) return;
    syncing = true;

    try {
      var root = drawerRoot();
      if (!root) return;

      var upsells = root.querySelector('.cart-upsells');
      if (!upsells) return;

      var cartMap = getCartOptionsFromDrawer();
      if (!cartMap) return;

      var color = cartMap.color || '';
      var size = cartMap.size || '';

      var cards = upsells.querySelectorAll('[data-product-id]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        rekeyCard(card);

        if (color) setRadioInCard(card, 'color', color);
        if (size) setRadioInCard(card, 'size', size);

        if (color && size) setSelectByTitle(card, color, size);
      }
    } finally {
      syncing = false;
    }
  }

  function syncSoon() {
    setTimeout(syncUpsellsFromDrawer, 0);
    setTimeout(syncUpsellsFromDrawer, 150);
    setTimeout(syncUpsellsFromDrawer, 400);
  }

  document.addEventListener('cart:updated', syncSoon);

  document.addEventListener('click', function (e) {
    var root = drawerRoot();
    if (!root) return;

    var btn = e.target && e.target.closest('.cart-upsells .c_col-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    btn.type = 'button';

    if (btn.dataset.adding === '1') return;
    btn.dataset.adding = '1';

    var card = cardOf(btn);
    if (!card) { btn.dataset.adding = '0'; return; }

    rekeyCard(card);
    syncUpsellsFromDrawer();

    var variantId = getVariantId(card);
    if (!variantId) { btn.dataset.adding = '0'; return; }

    btn.classList.add('is-loading');

    addToCart(variantId, 1)
      .then(function (added) {
        fire('ajaxProduct:added', { product: added || null });
        fire('cart:build', {});
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.dataset.adding = '0';
      });
  }, true);

  document.addEventListener('submit', function (e) {
    var root = drawerRoot();
    if (!root) return;
    if (!e.target || !e.target.closest('#CartDrawerForm')) return;
    if (e.submitter && e.submitter.closest('.cart-upsells')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSoon);
  else syncSoon();
})();